<ng-container *transloco="let t">
@if (currentQuestion) {
  <div>
    <div class="col-md-12 fv-row mt-3" style="min-height: 94px">
      <form id="checklistQuestionsForm" #checklistQuestionsForm="ngForm">

        <div class="card shadow-sm mb-5">
          <div class="card-header">
              <h3 class="card-title">{{isCurrentQuestionBorrowerSpecific ? ('For ' + borrowerName + '...') : 'For your transaction...'}}</h3>
          </div>
          <div class="card-body">
            <label for="multi-choice-question" class="form-label mb-2">{{ currentQuestionMetaData.questionText}}</label>
            @switch (currentQuestionMetaData.questionType) {
              @case ('MultiSelect') {
                <p-multiselect
                  name="question"
                  id="question"
                  optionLabel="answerText"
                  optionValue="questionAnswerId"
                  placeholder="Select one or more options"
                  [options]="currentQuestionMetaData.answers"
                  #currentQuestion="ngModel"
                  required
                  styleClass="custom-ng-multiselect"
                  [(ngModel)]="borrowersAnswersToQuestions[currentChecklistId][currentQuestionMetaData.questionId].choicesSelected"
                  [ngClass]="{'is-invalid': currentQuestion && currentQuestion.touched && currentQuestion.invalid}"
                  [style]="{ width: '100%' }"
                  [appendTo]="'body'"
                  [showToggleAll]="false"
                  [filter]="false">
                </p-multiselect>
              }
              @case ('SelectList') {
                <select name="question" id="question"
                  [ngClass]="{'is-invalid' : currentQuestion && currentQuestion.touched && currentQuestion.invalid}" required
                  #currentQuestion="ngModel" class="form-select form-select-solid"
                  [(ngModel)]="borrowersAnswersToQuestions[currentChecklistId][currentQuestionMetaData.questionId].choicesSelected[0]"
                  data-control="select2" data-placeholder="Choose one">
                  <option [ngValue]="undefined" disabled>{{ t('common.selectOne') }}</option>
                  @for (option of currentQuestionMetaData.answers; track option.questionAnswerId) {
                    <option [ngValue]="option.questionAnswerId">
                      {{option.answerText}}
                    </option>
                  }
                </select>
              }
              @case ('TriggerOnly') {
                <span>Trigger - will be skipped</span>
              }
              @default {
                <input class="form-control form-control-solid" autocomplete="off" #currentQuestion="ngModel"
                  [(ngModel)]="borrowersAnswersToQuestions[currentChecklistId][currentQuestionMetaData.questionId].singleAnswer"
                  placeholder="" id="question" name="question"
                  [ngClass]="{'is-invalid' : currentQuestion && currentQuestion.touched && currentQuestion.invalid}" required />
              }
            }
            <div class="invalid-feedback">Please, answer the question.</div>
          </div>
        </div>
      </form>
    </div>
  </div>
}
</ng-container>
